/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
	CircularProgress,
	Button,
	Avatar,
	FormControl,
	FormHelperText,
	Box,
	Typography,
} from '@material-ui/core';
import ReactS3Uploader from 'react-s3-uploader';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { Add, Edit } from '@material-ui/icons';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import {
	doGetSignedUrl,
	resizeImage,
	readImageFile,
	checkImageIsLoaded,
} from '../../../utils/imageUtils';
import ImageEditorComponent from '../ImageEditorComponent';
import GenericDialog from '../../dialog/GenericDialog';
import { showSnackbar } from '../../../utils/utils';
import _e from 'common/localeUtil';

class FieldFileUpload extends Component {
	constructor(props) {
		super(props);
		const initialUrl = props?.input?.value ? props.input.value : undefined;
		this.state = {
			files: [],
			loadingAvatar: false,
			signedUrlMap: {},
			waitAttempts: 0,
			uploadProgress: -1,
			compressing: false,
			url: initialUrl,
			editingImage: null,
		};

		this.uploader = React.createRef();
	}

	componentDidMount() {
		const initialUrl = this.props.input.value ? this.props.input.value : undefined;
		if (initialUrl?.url) this.loadSignedUrl(initialUrl?.url);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.input.value !== prevProps.input.value)
			this.setState({ url: this.props.input.value });
	}

	getBucket = () => {
		const { skipCompression } = this.props;
		if (skipCompression) {
			return process.env.REACT_APP_ENV === 'live'
				? 'goalsmapper-personal-branding'
				: 'goalsmapper-personal-branding-staging';
		}
		return (
			process.env.REACT_APP_S3BUCKETRAW ||
			(process.env.REACT_APP_ENV === 'live'
				? 'goalsmapper-personal-branding-raw'
				: 'goalsmapper-personal-branding-staging-raw')
		);
	};

	getCDNURL = (url) => {
		console.log('getCDNURL', url);
		const bucket = this.getBucket();
		if (process.env.REACT_APP_CDN_URL) {
			return url.replace(`${bucket}.s3.amazonaws.com`, process.env.REACT_APP_CDN_URL);
		}
		return url.replace(bucket, bucket.replace('-raw', ''));
	};

	onFileLoadedCallback = (compressedFileUrl, fileMeta) => () => {
		const { afterClick, multi } = this.props;
		const { signedUrlMap, url } = this.state;

		const signedUrl = signedUrlMap[compressedFileUrl];
		console.log(
			'FieldFileUploadControl:onCompressedCallback',
			compressedFileUrl,
			fileMeta,
			signedUrl,
			signedUrlMap,
		);

		const compressedSignedUrl = this.getCDNURL(signedUrl); //signedUrl.replace(bucket, bucket.replace("-raw", ""));

		console.log('FieldFileUploadControl:onCompressedCallback', compressedSignedUrl);
		const newFileMeta = {
			url: compressedFileUrl,
			signedUrl: compressedSignedUrl,
			name: fileMeta?.name,
			type: fileMeta?.type,
			size: fileMeta?.size,
		};
		let newUrl = newFileMeta;
		if (multi) {
			if (url) {
				newUrl = [...url, newFileMeta];
			} else {
				newUrl = [newFileMeta];
			}
		}
		this.setState({
			uploadProgress: -1,
			url: newUrl,
		});
		const {
			input: { onChange },
		} = this.props;
		// console.log('FieldFileUploadControl onChange', onChange);
		onChange(newUrl);
		if (afterClick) {
			afterClick();
		}
	};

	async onComplete(signResult) {
		const { skipCompression } = this.props;
		const { url, files } = this.state;
		let { signedUrl } = signResult;
		const fileUrl = signedUrl.replace(/\?.*$/, '');
		const fileName = this.getFileNameFromUrl(fileUrl);
		const fileMeta = files && files.find((f) => f.name.replace(/[^\w-\.]/g, '') === fileName);
		const compressedFileUrl = this.getCDNURL(fileUrl); //fileUrl.replace(bucket, bucket.replace("-raw", ""));
		// await this.loadSignedUrl(compressedFileUrl, this.onCompressedCallback(compressedFileUrl, fileMeta));
		console.log('FieldFileUploadControl:onComplete', compressedFileUrl, fileMeta, signResult);
		const signedUrlMap = await this.loadSignedUrl(
			compressedFileUrl,
			this.onFileLoadedCallback(compressedFileUrl, fileMeta),
		);
		console.log('FieldFileUploadControl:onComplete', skipCompression, signedUrlMap);
		if (skipCompression) {
			this.onFileLoadedCallback(compressedFileUrl, fileMeta)();
		}

		// new signedUrl
	}

	delay = (ms) => new Promise((res) => setTimeout(res, ms));

	waitForImageCompressionToComplete = async (signedUrl, callback) => {
		console.log('FieldFileUploadControl checkImage before', signedUrl);
		let result = await checkImageIsLoaded(signedUrl);
		let counter = 10;
		while (counter > 0 && !result?.ok) {
			await this.delay(5000);
			result = await checkImageIsLoaded(signedUrl);
			counter = counter + 1;
		}
		if (result?.ok) {
			this.setState({
				compressing: false,
			});
			callback && callback();
		}

		return result;
	};

	loadSignedUrl = async (url, callback) => {
		const { isPublic, skipCompression } = this.props;
		if (!skipCompression) {
			this.setState({
				compressing: true,
			});
		}

		/**
		 * 21 Oct 2021 [XG]: Because we are now uploading to a temp S3 Bucket and letting the image compress first, we have to
		 * wait until the image compression is ready before the image will appear in the bucket.
		 */
		try {
			const response = await doGetSignedUrl(url, isPublic);

			const signedUrl = response?.url;

			if (!skipCompression) {
				this.waitForImageCompressionToComplete(signedUrl, callback);
			}
			const signedUrlMap = Object.assign(this.state.signedUrlMap, { [url]: signedUrl });
			this.setState((state) => ({
				loadingAvatar: false,
				signedUrlMap,
			}));
			console.log('FieldFileUploadControl:loadSignedUrl', signedUrlMap, signedUrl, response);
			return signedUrlMap;
		} catch (e) {
			console.log('Exception', e);
			this.setState({
				loadingAvatar: false,
				compressing: false,
			});
			return null;
		}
	};

	getFileNameFromUrl = (url) => {
		const segments = url.split('/');
		// console.log(segments, url);
		return segments[segments.length - 1];
	};

	onSignedUrl = (response) => {
		// console.log(response);
	};

	onUploadProgress = (percent, message) => {
		// console.log('FieldFileUploadControl onUploadProgress', percent);
		const { onFileUploadProgress } = this.props;
		// console.log(`upload progress - ${percent}`);
		this.setState({ uploadProgress: percent });
		onFileUploadProgress && onFileUploadProgress(percent);
	};

	onUploadError = (message) => {
		console.log('FieldFileUploadControl onUploadError', message);
		showSnackbar({
			text: 'Upload failed, please try again!',
			pos: 'top-center',
			showAction: false,
			backgroundColor: '#D32F2F',
			textColor: '#fff',
		});
		this.setState({ uploadProgress: -1 });
	};

	onEditorCancel = () => {
		this.uploader.current.abort();
		this.uploader.current.clear();
		this.setState({
			editingImage: null,
		});
	};

	removeImage = () => {
		const { input, afterClick } = this.props;

		this.setState({
			url: null,
			editingImage: null,
		});
		input.onChange(null);
		if (afterClick) {
			afterClick(null);
		}
	};

	preprocess = (file, callback) => {
		const { onErrorCallBack } = this.props;
		const maxLenInBytes = 2000000; // 2MB
		if (file.size > maxLenInBytes) {
			console.error('Image size is greater than limit', maxLenInBytes);
			onErrorCallBack && onErrorCallBack(`Image file size is greater than 2MB limit`);
			return;
		}
		console.log('FieldFileUploadControl preprocess', callback);
		const { maxWidth, maxHeight, onFilePreprocess, showImageEditor } = this.props;
		if (showImageEditor) {
			readImageFile(file).then((img) => {
				this.setState((state) => ({
					files: [file, ...state.files],
					processCallback: callback,
					editingImage: img,
				}));
			});
		} else if (maxWidth) {
			console.log('resize image', maxWidth);
			readImageFile(file)
				.then((image) => {
					// console.log('FieldFileUploadControl readImageFile', image);
					return resizeImage(
						image,
						{ width: maxWidth, height: maxHeight },
						file.type,
						file.name,
					);
				})
				.then((resizedImage) => {
					console.log('FieldFileUploadControl resizedImage', resizedImage);
					onFilePreprocess && onFilePreprocess(file);
					callback(resizedImage);
					this.setState((state) => ({
						files: [file, ...state.files],
					}));
				});
		} else {
			onFilePreprocess && onFilePreprocess(file);
			this.setState((state) => ({
				files: [file, ...state.files],
			}));
			callback(file);
		}
	};

	renderPrompt = () => {
		const { customIcon, iconWidth, iconHeight, classes } = this.props;
		if (customIcon) {
			return customIcon;
		}
		// <ArrowUpwardIcon style={{ width: iconWidth, height: iconHeight }} />;
		return (
			<div className={`add-image ${classes.placeholder}`}>
				<ArrowUpwardIcon />
				<div className="text">Add an image</div>
			</div>
		);
	};

	renderHover = () => {
		const { hoverEdit, previewClass, customTitle } = this.props;
		if (hoverEdit) {
			const title = this.state.url ? _e('change_image') : _e('upload_image');
			const Icon = this.state.url ? Edit : Add;
			return (
				<div
					title={customTitle || title}
					className={`hover-edit hover-element ${previewClass}`}
				>
					<Icon size={15} />
					{title}
				</div>
			);
		}

		return false;
	};

	renderProgress = () => {
		const { uploadProgress, skipCompression, compressing } = this.state;
		console.log('FieldFileUpload:renderProgress', uploadProgress);
		if (uploadProgress > 0 && (skipCompression || !compressing)) {
			return (
				<Box
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
				>
					<CircularProgress
						size={50}
						variant="determinate"
						color="secondary"
						value={uploadProgress}
					/>
					<Typography variant="body2" className="pt-2">
						{_e('uploading')}
					</Typography>
				</Box>
			);
		}
		return null;
	};

	renderCompressionProgress = () => {
		const { compressing, uploadProgress } = this.state;
		console.log('render compressing', compressing, uploadProgress);
		if (uploadProgress === 100 && compressing) {
			return (
				<Box
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
				>
					<CircularProgress size={50} variant="indeterminate" color="primary" />
					<Typography variant="body2" className="pt-2">
						{_e('compressing')}
					</Typography>
				</Box>
			);
		}
		return null;
	};

	renderUploadComponent = () => {
		const { acceptFiles, autoUpload, s3Path, className, multi, name, style, inputRef } =
			this.props;

		const bucket = this.getBucket();

		return (
			<ReactS3Uploader
				className={`${className} clickable`}
				style={style}
				title={'Change image'}
				name={name}
				ref={this.uploader}
				multiple={multi}
				onSignedUrl={this.onSignedUrl}
				preprocess={this.preprocess}
				onError={this.onUploadError}
				onProgress={this.onUploadProgress}
				onFinish={(signResult) => this.onComplete(signResult)}
				signingUrlQueryParams={{
					s3Path,
					s3Bucket: bucket,
					acl: 'public-read',
				}}
				signingUrl={`${process.env.REACT_APP_BASE_API_URL}/private/rest/upload/s3/sign/`}
				accept={acceptFiles || 'image/*'}
				uploadRequestHeaders={{
					'x-amz-acl': 'public-read',
				}}
				autoUpload={autoUpload}
				// signingUrlHeaders={{ Authorization: `JWT ${token}` }}
				// signingUrlWithCredentials
				contentDisposition="auto"
				inputRef={inputRef}
			/>
		);
	};

	renderDefaultAvatar = (imageUrl) => {
		const { width, height, notAvatar } = this.props;
		let styles = { width, height };
		if (notAvatar) {
			styles = {
				width,
				height,
				overflow: 'visible',
			};
		}

		console.log('FieldFileUploadControl renderDefaultAvatar', imageUrl);
		const imageSrc = typeof imageUrl === 'object' ? imageUrl.signedUrl : imageUrl;
		return (
			<div className={`defaultAvatar`}>
				<div className={`clickimagetoupload`}>Click on image below to upload new image</div>
				<Avatar src={imageSrc} style={styles} />
			</div>
		);
	};

	renderAvatar = ({ url }) => {
		const { width, height, notAvatar } = this.props;
		const { signedUrlMap, compressing, loadingAvatar } = this.state;

		let styles = { width, height };
		if (notAvatar) {
			styles = {
				width,
				height,
				overflow: 'visible',
			};
		}

		if (signedUrlMap[url]) {
			return <Avatar src={signedUrlMap[url]} style={styles} />;
		}
		if (loadingAvatar || compressing) {
			return (
				<Avatar style={styles}>
					<CircularProgress variant="indeterminate" />
					<Typography variant="body3">Uploading...</Typography>
				</Avatar>
			);
		}
		return this.renderPrompt();
	};

	onEditorSave = (img) => {
		const { processCallback, files } = this.state;
		const { maxWidth, maxHeight } = this.props;
		if (maxWidth) {
			const file = files[0];
			resizeImage(img, { width: maxWidth, height: maxHeight }, file.type, file.name).then(
				(resizedImage) => {
					processCallback(resizedImage);
				},
			);
		} else {
			processCallback(img);
		}
		this.setState({
			editingImage: null,
		});
	};

	renderEditImageContent = () => {
		const { editingImage } = this.state;
		const { cropRatio } = this.props;
		return (
			<Box display="flex" p={2} justifyContent="center" alignSelf="center">
				<ImageEditorComponent
					onCancel={this.onEditorCancel}
					imageSrc={editingImage}
					onSave={this.onEditorSave}
					canvasRatio={cropRatio}
					cropperScale={{
						min: 0.2,
						max: 3,
					}}
				/>
			</Box>
		);
	};

	render() {
		const { uploadProgress, editingImage, url } = this.state;
		const {
			enableProgress,
			disablePreview,
			input,
			componentType,
			transparent,
			theme,
			help,
			multi,
			width,
			height,
			meta,
			disabled,
			disableGutters,
			notAvatar,
			classes,
			defaultAvatar,
			showImageEditor,
			skipCompression,
			variant,
		} = this.props;
		let component = null;
		// not uploading
		if (uploadProgress === -1 || !enableProgress) {
			// Test always render avatar
			if (defaultAvatar) {
				component = this.renderDefaultAvatar(defaultAvatar);
			} else if (url && !disablePreview) {
				const fileObject = multi ? url[0] : url;
				component = this.renderAvatar(fileObject);
			} else {
				component = this.renderPrompt();
			}
		} else {
			component = null;
		}

		let RootComponent = Avatar;

		let styles = {
			borderColor: transparent ? 'transparent' : theme.palette.text.secondary,
			backgroundColor: transparent ? 'transparent' : theme.palette.text.disabled,
			width: width || height,
			height,
		};
		if (notAvatar) {
			styles = {
				...styles,
				overflow: 'visible',
			};
		}
		let rootComponentType = 'button';
		if (componentType === 'button') {
			RootComponent = Button;
			rootComponentType = 'button';
		} else {
			RootComponent = Avatar;
			rootComponentType = 'div';
		}

		// console.log("Profile image", this.state.url);
		return (
			<FormControl
				className={`form-control-wrapper file-upload file-upload-center ${
					disableGutters ? 'no-label' : ''
				} ${classes.root}`}
				id={`id_${input.name}`}
				disabled={disabled}
			>
				<RootComponent
					component={rootComponentType}
					className="file-upload-content-area clickable"
					style={styles}
					variant={variant}
				>
					{this.renderUploadComponent()}
					{component}
					{enableProgress && this.renderProgress()}
					{enableProgress && !skipCompression && this.renderCompressionProgress()}
					{this.renderHover()}
				</RootComponent>
				{url && (
					<Button
						variant="text"
						classes={{ label: classes.removeButtonLabelStyle }}
						size="small"
						onClick={this.removeImage}
						id="remove-photo-button"
					>
						{'Remove image'}
					</Button>
				)}
				{help && <FormHelperText variant="outlined">{help}</FormHelperText>}
				{meta.touched &&
					((meta.error && (
						<span className="error-msg">
							<i className="fa fa-times-circle" />
							&nbsp;{meta.error}
						</span>
					)) ||
						(meta.warning && <span className="warning-msg">{meta.warning}</span>))}

				{showImageEditor && (
					<GenericDialog
						title="Edit Image"
						maxWidth="sm"
						showTitleDivider
						fullWidth={false}
						open={!!editingImage}
						handleClose={this.onEditorCancel}
						content={this.renderEditImageContent()}
						hideConfirmButton
						minWidth={10}
					/>
				)}
			</FormControl>
		);
	}
}

const styles = (theme) => ({
	removeButtonLabelStyle: {
		color: theme.palette.error.main,
	},
	imageEditorContainer: {
		display: 'flex',
		padding: theme.spacing(2),
		justifyContent: 'center',
		alignSelf: 'center',
	},
	imageEditor: {
		// maxWidth: 200
	},
	placeholder: {},
});

FieldFileUpload.defaultProps = {
	iconHeight: 80,
	autoUpload: true,
	hoverEdit: true,
	enableProgress: true,
	isPublic: false,
	showImageEditor: false,
	maxWidth: 2000,
	maxHeight: 2000,
	skipCompression: true,
};

FieldFileUpload.propTypes = {
	theme: PropTypes.object,
	componentType: PropTypes.oneOf(['fragment', 'button', 'avatar']),
	onFilePreprocess: PropTypes.func,
	onFileUploadProgress: PropTypes.func,
	customTitle: PropTypes.string,
	multi: PropTypes.bool,
	transparent: PropTypes.bool,
	customIcon: PropTypes.object,
	s3Path: PropTypes.string.isRequired,
	input: PropTypes.object.isRequired,
	style: PropTypes.object,
	help: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	token: PropTypes.string,
	disabled: PropTypes.bool,
	meta: PropTypes.object,
	disablePreview: PropTypes.bool,
	previewClass: PropTypes.string,
	hoverEdit: PropTypes.bool,
	afterClick: PropTypes.func,
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
	cropRatio: PropTypes.number,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.number,
	iconWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	iconHeight: PropTypes.number,
	disableGutters: PropTypes.bool,
	acceptFiles: PropTypes.string,
	autoUpload: PropTypes.bool,
	enableProgress: PropTypes.bool,
	notAvatar: PropTypes.bool,
	isPublic: PropTypes.bool,
	showImageEditor: PropTypes.bool,
	classes: PropTypes.object,
	inputRef: PropTypes.any,
	skipCompression: PropTypes.bool,
};

export default compose(withTheme, withStyles(styles))(FieldFileUpload);
